module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', _vm._l((_vm.service_history_clara), function(history, index) {
    return _c('div', {
      staticClass: "box"
    }, [_c('article', {
      staticClass: "media"
    }, [_c('div', {
      staticClass: "media-content"
    }, [_c('div', {
      staticClass: "content"
    }, [_c('p', [_c('strong', [_vm._v(_vm._s(history.type.toUpperCase().replace('.', ' ')))]), _vm._v(" "), _c('br'), _vm._v(" "), _c('br')]), _c('p', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (history.status),
        expression: "history.status"
      }]
    }, [_c('strong', [_vm._v("Card Status:")]), _vm._v(" " + _vm._s(history.status) + " ")]), _vm._v(" "), _c('p', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (history.last4),
        expression: "history.last4"
      }]
    }, [_c('strong', [_vm._v("Virtual Card:")]), _vm._v(" **** ****** *" + _vm._s(history.last4))]), _vm._v(" "), _c('p', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (history.limit),
        expression: "history.limit"
      }]
    }, [_c('strong', [_vm._v("Virtual Card Limit:")]), _vm._v(" " + _vm._s(history.limit) + " BRL")]), _vm._v(" "), _c('p', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (history.charged),
        expression: "history.charged"
      }]
    }, [_c('strong', [_vm._v("Virtual Card Charged:")]), _vm._v(" " + _vm._s(history.charged) + " BRL")]), _vm._v(" "), _c('small', [_vm._v("System")]), _vm._v(" "), _c('small', {
      staticStyle: {
        "float": "right"
      }
    }, [_vm._v("Created: " + _vm._s(history.created_at))]), _vm._v(" "), _c('p')])])])])
  }), 0)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2b81f390","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./client/components/services/HistoryClara.vue
// module id = 1094
// module chunks = 39